import type { FaireProductEntity } from "../../entity_types/product";

export const p_xjheud2fr3: FaireProductEntity = {
  token: "p_xjheud2fr3",
  type: "product",
  name: "Immunity Support Lollipops/lozenges 3-Pack (5ct)",
  brandToken: "b_vdsn2grmc4",
  brandName: "Unknown Brand",
  imageUrl: "https://cdn.faire.com/fastly/612bb93f85e4631e226d470a6fa7e02816bc78a4e11e919ec314f1ce9c666b8c.webp",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f561ce7934dc226af26f9643ade2796c58765751aabf19698099d0fa495cedf0.png",
    "https://cdn.faire.com/fastly/46475175e7fd70ae91903ac6f968b85f92baffd7a909ef20130a10ae3a4a33c4.jpeg",
    "https://cdn.faire.com/fastly/7d1d7c370af2edfe1fa502df44e2a4a2faa9c8eb1500c6f4a05b46a325d33838.webp",
    "https://cdn.faire.com/fastly/ad78d2f9c6015bd4e2b53aa6779300f98e46f8f65ba909dd4d37635b71026bdc.webp",
    "https://cdn.faire.com/fastly/8ac4a0313db3a8cb2cba702a8ed47dc2569477ce814ae0b3269d8b0f2e468955.webp",
    "https://cdn.faire.com/fastly/d97f22869baf5b5f1de1d7c579f9fc4f83ef37eb8da1284232eda8c4c6471ab6.jpeg",
    "https://cdn.faire.com/fastly/259db264dc01c40a7a619dde7ae76e79ff60d43a5feda93fbcfec6e5835ad6ee.jpeg"
  ],
  priceDollars: 6.23,
  description: "Organic Herbal Immunity Support Lollipop Bundle made with clean, organic ingredients for everyday wellness in a kid-friendly format for ages 3+.\n\nA great-tasting alternative to pills, powders, and gummies, designed for on-the-go routines like school, travel, and busy family days.\n\nFeatures and details:\n\nBundle contents: 30 total pouches (10 pouches per flavor), 5 lollipops per pouch\n\nMade with: organic raw wildflower honey\n\nClean label: organic, non-GMO, gluten-free, dairy-free\n\nFree from: high-fructose corn syrup, artificial sweeteners\n\nGreat for: boutiques, apothecaries, wellness shops, pharmacies, gift stores, children’s retailers, and natural food stores\n",
  tags: [],
  msrpDollars: 12.46,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:27:44.002Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
